/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OutreachPurpose = {
    Invitation: 'invitation',
    Reminder: 'reminder',
    MessageNotification: 'message_notification',
    Escalation: 'escalation',
    StaffNotification: 'staff_notification',
} as const;
export type OutreachPurpose = typeof OutreachPurpose[keyof typeof OutreachPurpose];


export function instanceOfOutreachPurpose(value: any): boolean {
    for (const key in OutreachPurpose) {
        if (Object.prototype.hasOwnProperty.call(OutreachPurpose, key)) {
            if (OutreachPurpose[key as keyof typeof OutreachPurpose] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OutreachPurposeFromJSON(json: any): OutreachPurpose {
    return OutreachPurposeFromJSONTyped(json, false);
}

export function OutreachPurposeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachPurpose {
    return json as OutreachPurpose;
}

export function OutreachPurposeToJSON(value?: OutreachPurpose | null): any {
    return value as any;
}

export function OutreachPurposeToJSONTyped(value: any, ignoreDiscriminator: boolean): OutreachPurpose {
    return value as OutreachPurpose;
}

